<!-- 快应用落地页管理 -->
<template>
<div>
	<div :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- 标题 -->
		<div class="page-title">快应用落地页管理</div>
		
		<!-- 筛选条件 -->
		<div style="margin: 10px 0 0;">
			<div style="display: flex;align-items: center;flex-wrap: wrap;">
				
				<div class="screen-box">
					<div class="screen-label">落地页名称</div>
					<a-input v-model="r_name" allowClear placeholder="请输入" style="width: 200px;"/>
				</div>
				
				<div class="screen-box">
					<div class="screen-label">快应用平台</div>
					<a-select
						style="min-width: 200px"
						placeholder="请选择快应用平台"
						@change="handleChangeH"
						:getPopupContainer="getsPopupContainer" 
						allowClear
					  >
						<a-select-option v-for="(value,key) in qaSelectData.qk_platform" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="screen-box">
					<div class="screen-label">推广链接</div>
					<a-select
						style="min-width: 300px;max-width: 600px;"
						placeholder="请选择推广链接"
						notFoundContent="← 请先选择: 快应用平台 或 平台没有内容" 
						:filter-option="false"
						@change="handleChangeB"
						:getPopupContainer="getsPopupContainer" 
						@popupScroll="popupScrollCEshi" 
						showSearch
						allowClear
						@search="selectZhSearch"
						:not-found-content="s_fetching ? undefined : null" 
						@blur="zhBlur"
					  >
						<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
						<a-select-option v-for="(item,index) in tgSelectData" :key="item.id" :value="item.id">
						  {{item.name || '空'}}
						</a-select-option>
						<a-select-option v-if="loading_more_hint" value="-0-">
							<div style="color:rgb(98, 168, 234)">加载更多中...</div>
							
						</a-select-option>
					</a-select>
				</div>
				
				<a-button @click="searchButton('button')" :loading="search_button_loading"  type="primary" icon="search" class="screen-box">搜索</a-button>
			
				<a-button @click="addShowDrawer()" type="primary" icon="plus" class="screen-box"  style="background-color: #67c23a;border-color: #67c23a;">新增落地页</a-button>
				
			</div>
		</div>
	</div>
	</div>
	
	
	<div style="">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':check_width + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px',}">
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px',}">
					{{rableTitle[1].title}}
				</div>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" v-if="index > 1"
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div>
			<!-- <div  :style="{'height':table_body_height + 'px', 'width':(rableTitle[0].width + rableTitle[1].width) + 'px'}" style="background-color: #fff;position: absolute;"></div> -->
			<div  ref="tdHeight" v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;" :style="{'height': item.height + 'px'}">
					<!-- 选择 -->
					<div class="table-td-cell" :style="{'width':check_width + 'px'}">
						<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
					</div>
					<!-- ID -->
					<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
						{{item.id}}
					</div>
					<!-- 落地页名称 -->
					<!-- <div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
						<div v-if="!item.title_input_control" @click="ldTitleClick(item)" style="color: #62a8ea;cursor: pointer;">{{item.title}}</div>
						<a-input v-else @blur="LdTitleChange($event,item,index)" ref="title_input" :value="item.title" placeholder="Basic usage" />
					</div> -->
					<div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
						{{item.title}}
						
					</div>
				</div>
				<!-- 落地页链接 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					<div>
						<span>投放地址：</span>
						<a-icon @click="thDzCopy(item.put_url)" type="copy" style="font-size: 13px;cursor: pointer;"/>
					</div>
					<div>{{item.put_url}}</div>
					<div v-if="item.put_platform === '头条' || item.put_platform === '百度'" style="margin-top: 7px;">
						<span>联调地址：</span>
						<a-icon  @click="thLtCopy(item)" type="copy" style="font-size: 13px;cursor: pointer;"/>
					</div>
					<div v-if="item.put_platform === '头条'">{{`${item.put_url}?liantiao=1`}}</div>
					<div v-else-if="item.put_platform === '百度'">{{`${item.put_url}?bd_vid={bd_vid}&liantiao=1`}}</div>
				</div>
				<!-- 快应用推广链接平台 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
					{{item.qk_platform_name}}
				</div>
				<!-- 快应用推广链接id -->
				<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
					<div v-if="item.link">{{item.link.name}}（{{item.link.link_id}}）</div>
				</div>
				
				<!-- 投放平台 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
					{{item.put_platform | putPlatformFil}}
				</div>
				<!-- 落地页域名id -->
				<!-- <div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
					{{item.put_domain}}
				</div> -->
				
				<!-- 回传比例 -->
				<!-- <div @click="editTd(item,1)" class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					{{item.report_per}}
				</div> -->
				<!-- 落地页类型 -->
				<div class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
					{{item.jump_type | jumpTypeFil}}
				</div>
				<!-- 快应用平台名称 -->
				<!-- <div class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					{{item.qk_platform_name}}
				</div> -->
				<!-- 操作 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}" style="display: flex;flex-wrap: wrap;">
					<div @click="editLand(item)" class="td-cz" style="color: #e6a23c;">编辑</div>
					<div @click="thDel(item)" class="td-cz" style="color: red;">删除</div>
					
				</div>
				<!-- 创建时间 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
					{{item.created_at}}
				</div>
				<!-- 更新时间 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}">
					{{item.updated_at}}
				</div>
			</div>
			
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_null_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div>
	</div>
	
	<!-- 批量删除 -->
	<a-modal v-model="dl_modal" title="批量删除" okType="danger" width="700px"
	  okText="删除" cancelText="取消"
	  @ok="dlOk" @cancel="dlCancel" :confirmLoading="dl_loading">
	    <div style="">
			<div style="margin-bottom: 10px;">已选的删除项：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 15px;" class="">
					<div style="width: 80px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 195px;">{{item.title}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	
	<!-- 回传比例相关侧边栏 -->
	<a-drawer
	  :title="hc_drawer_title"
	  width="700px"
	  placement="right"
	  :closable="false"
	  :visible="hc_visible"
	  @close="hcCloseDrawer"
	>
		<div v-if="hc_drawer_title == '添加回传比例任务'" style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">落地页名称</div>
					
				<div style="font-size: 15px;">{{hc_land_title}}</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">日期范围</div>
					
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false" 
				:disabledDate="disabledDate"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">定时任务</div>
				
				<div>
					<div v-for="(item,index) in hcTimeData" :key="index" style="display: flex;align-items: center;margin-bottom: 10px;">
						<div style="display: flex;align-items: center;margin-right: 20px;">
							<div class="hc-drawer-title">时间点</div>
								
							<a-time-picker :open.sync="item.hc_time_open2" :value="moment(item.hc_time_value, 'HH:mm:ss')" @change="(...defaultArgs) => hcTimeChange(defaultArgs,index)" :getPopupContainer="getsPopupContainer" :allowClear="false">
								<a-button slot="addon" size="small" type="primary" @click="hcTimeClose(index)">
									确认
								</a-button>
							</a-time-picker>
						</div>
						
						<div style="display: flex;align-items: center;margin-right: 20px;">
							
							<div class="hc-drawer-title">回传比例</div>	
							<a-input-number id="inputNumber" v-model="item.hc_number_value" :min="0" :max="100"  />
						</div>
						
						<a-button @click="delTimeData(index)" type="danger" size='small'>删除</a-button>
					</div>	
				</div>
				
			</div>
			<div class="form-cell-box" style="margin-top: -15px;margin-bottom: 35px;">
				<div class="class-title"></div>
				<a-button @click="pushHcTimeData" type="primary" size='small' style="margin-right: 10px;">添加定时任务</a-button>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">开启</div>
					
				<a-switch @change="hcDrawerSwitch" :checked="hc_switch_checked" checked-children="打开" un-checked-children="关闭" />
			</div>
			
			<div style="color: red;height: 23px;margin-top: 35px;margin-bottom: -10px;margin-left: 40px;">{{hc_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="hcRequest" :loading="hc_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="hcCloseDrawer">取消</a-button>
			</div>
		</div>
		
		<div v-else-if="hc_drawer_title == '回传比例修改记录'">
			<!-- 表头 -->
			<div class="table-th" :style="{'width': (hcTableData[0].width + hcTableData[1].width + hcTableData[2].width + hcTableData[3].width + hcTableData[4].width) + 'px'}">
				
				<div  v-for="(item,index) in hcTableData" :key="index" >
					<div class="table-th-cell" 
					:style="{'width':item.width + 'px',}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in hcTableShowData" :key="index" class="table-td"  :style="{'width': (hcTableData[0].width + hcTableData[1].width + hcTableData[2].width + hcTableData[3].width + hcTableData[4].width) + 'px'}">
				<!-- 落地页ID -->
				<div  class="table-td-cell" :style="{'width':hcTableData[0].width + 'px'}">
					{{item.link_id}}
				</div>
				<!-- 落地页修改比率 -->
				<div  class="table-td-cell" :style="{'width':hcTableData[1].width + 'px'}">
					{{item.report_per}}
				</div>
				<!-- 落地页历史比率 -->
				<div  class="table-td-cell" :style="{'width':hcTableData[2].width + 'px'}">
					{{item.old_report_per}}
				</div>
				<!-- 操作人 -->
				<div  class="table-td-cell" :style="{'width':hcTableData[3].width + 'px'}">
					{{item.op_name}}
				</div>
				<!-- 操作时间 -->
				<div  class="table-td-cell" :style="{'width':hcTableData[4].width + 'px'}">
					{{item.created_at}}
				</div>
				
			</div>
			<div v-show="hcTableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
			
			<!-- 分页 -->
			<div style="width: 100%;text-align: center;margin: 35px auto;">
				<a-pagination v-model="hc_page" :pageSize="hc_limit" :total="hc_total" @change="hcPaginationChange"  />
			</div>
			
		</div>
	</a-drawer>
	
	
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      :title="`编辑`"
	      :visible="edit_visible"
	      :confirm-loading="edit_confirmLoading"
		  cancelText="取消"
		  okText="确认" 
		  width="500px" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
		  
	    >
		
		<div class="form-cell-box">
			<div class="class-title" >回传比例</div>
				
			<a-input v-model="e_report_per" style="width: 240px;" placeholder="请输入" />
		</div>
		
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { landQAList, landQASelect, landQaDel, putDataMenu, editActivePayStatus, landPageLinkDelete, landPageLinkCopy, landPageSingleEdit, setReportPerPlan, logReportPer } from '@/request/api'	
export default {
	name: 'landQuickApp_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-06-12',
			endTime: '2022-06-25',
			
			// 筛选条件部分
			filterData: {
				op_id:{ // 投手
					list: [{}],
				},
				channel_id:{ // 书城渠道
					list: [{}],
				},
				gzh_id:{ // 公众号
					list: [{}],
				},
				
			}, // 筛选条件数组
			
			r_page: 1, // 页数
			r_limit: 20, // 每页多少条
			table_total: 0, // 总数
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:70, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"落地页名称", width:130, type:"title", },
				{title:"落地页链接", width:290, type:"put_url", },
				{title:"快应用平台", width:120, type:"qk_platform_name", },
				{title:"推广链接", width:200, type:"link_id", },
				{title:"投放平台", width:110, type:"put_platform", },
				// {title:"落地页域名id", width:210, type:"put_domain", },
				{title:"落地页类型", width:110, type:"jump_type", },
				// {title:"快应用平台名称", width:160, type:"qk_platform_name", },
				{title:"操作", width:130, type:"cz", },
				{title:"创建时间", width:150, type:"created_at", },
				{title:"更新时间", width:150, type:"updated_at", },
			],
			tableShowData: [],
			search_button_loading: false,
			table_scroll_width: 1600,
			body_width: 1600,
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			table_body_height: 2400,
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selected_number: 0, // 已选数量
			selectedData: [], // 选中的数据
			check_width: 50, // 表格内选择框的宽度
			
			// 批量删除弹窗
			dl_modal: false,
			dl_loading: false,
			
			// 复制
			copy_visible: false,
			copy_confirmLoading: false,
			copyModalObj: {}, // 点击的表格行内容
			
			// 回传比例侧边栏
			hc_link_id: "", // 回传id
			hc_drawer_title: "", // 标题
			hc_visible: false, 
			hc_button_loading: false, // 回传侧边栏确认按钮的加载状态
			hc_land_title: "", // 回传落地页名称
			hc_time_open2: false,
			hc_time_value: '00:00:00', // 回传比例侧边栏的时间选择框
			hc_number_value: 100, // 回传比例
			hc_switch_checked: false, // 回传比例侧边栏开关按钮
			hcTimeData: [
				{hc_time_value: '00:00:00', hc_number_value: 100, hc_time_open2: false,}
			],
			hc_form_hint: "", // 侧边栏新增表单的验证提示
			hcTableData: [
				{title:"落地页ID", width:90, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"落地页修改比率", width:130, type:"title", },
				{title:"落地页历史比率", width:130, type:"put_url", },
				{title:"操作人", width:100, type:"gzh_name", },
				{title:"操作时间", width:160, type:"top_image", },
			],
			hcTableShowData: [],
			hc_page: 1,
			hc_limit: 10,
			hc_total: 0,
			
			
			role_control: [], // 用户权限控制
			
			// 单个编辑弹窗
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			edit_confirmLoading: false,
			e_id: "", // 修改id
			e_report_per: "", // 修改回传比例
			
			ld_change_tilte: "", // 更改前的落地页名称
			
			
			// 快应用落地页搜索条件下拉
			qaSelectData: {},
			
			r_name: null, // 落地页名称
			r_link_id: null, // 快应用平台推广链接id
			r_qk_platform: null, // 快应用平台
			
			// 快应用推广链接下拉框
			s_page: 1,
			s_limit: 100,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			tgSelectData: [], // 快应用推广链接
			blurTgData: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
		}
	},
	mounted() {
		let that = this
		
		that.search_button_loading = true
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle, that.check_width)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		// console.log("date2.getDate();",date2.getDate())
		that.startTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		
		// 获取7天后日期
		let date1 = new Date(new Date().getTime() + 604800000);
		let month1
		if(date1.getMonth() + 1 < 10){
			month1 = '0' + (date1.getMonth() + 1)
		}
		else {
			month1 = date1.getMonth() + 1
		}
		let day1
		if(date1.getDate() < 10){
			day1 = "0" + date1.getDate()
		}
		else {
			day1 = date1.getDate()
		}
		that.endTime = date1.getFullYear() + "-" + month1 + "-" + day1
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		putDataMenu().then(res=>{
			console.log("筛选条件",res.data.data)
			that.filterData = res.data.data.filter
			
			that.searchButton()
		})
		
		
		landQAList().then(res=>{
			console.log("快应用落地页列表",res);
		})
		
		landQASelect().then(res=>{
			console.log("快应用下拉联动",res);
			that.qaSelectData = res.data.data
			// that.tgSelectData = res.data.data.list
			// that.blurTgData = res.data.data.list
		})
	},
	updated(){ // 
		// console.log("数据更新");
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeH(e){ // 快应用平台
			console.log(e)
			let that = this
			this.r_qk_platform = e
			that.search_button_loading = true
			landQASelect({
				type: e,
				page: that.s_page,
				limit: that.s_limit,
			}).then(res=>{
				that.search_button_loading = false
				// console.log("快应用下拉联动",res);
				that.tgSelectData = res.data.data.list
				that.blurTgData = res.data.data.list
			})
		},
		
		// 快应用推广链接id下拉框选择-开始
		handleChangeB(e){ // 快应用平台推广链接id
			// console.log(e);
			this.r_link_id = e
		},
		popupScrollCEshi(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					landQASelect({
						page: that.s_page,
						limit: that.s_limit,
						name: that.s_adv_name,
						type: that.r_qk_platform
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.tgSelectData 
						that.loading_more_hint = false
						that.tgSelectData = data.concat(res.data.data.list) 
						that.s_fetching = false
						that.loading_more_control = true
					})
				}
				
				
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.tgSelectData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			landQASelect({
				page: 1,
				limit: that.s_limit,
				name: e,
				type: that.r_qk_platform
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.tgSelectData = res.data.data.list
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.tgSelectData = that.blurTgData 
		},
		// 快应用推广链接id下拉框选择-结束
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type != '分页'){
				that.selectedData = [] // 已选内容清空
			}
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				page: that.r_page, // 页数
				limit: that.r_limit, // 每页多少条
				name: that.r_name, // 落地页名称
				link_id: that.r_link_id, // 快应用平台推广链接id
				qk_platform: that.r_qk_platform, // 快应用平台
			}
			
			landQAList(r_data).then(res=>{
				console.log("搜索结果",res.data.data)
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					
					let data = res.data.data.data
					// 这里这么做是为了把height这个属性变成响应式的。不然下面给height添加每行的高度，页面不会响应。当然也可以用this.$set
					data.forEach((res,index)=>{
						res.height = 59
						res.checked = false
						res.open_put_loading = false // 是否打开投放loading
						
						res.title_input_control = false // 落地页名称修改的input控制
						
					})
					console.log("data",data)
					
					
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					
					
					that.tableShowData = data // 整个数组替换，里面属性会变成响应式
					
					
					setTimeout((res=>{ // 必须要等渲染完了，才能去获取
						// console.log("that.$refs.tdHeight",that.$refs.tdHeight)
						// that.table_body_height = that.$refs.tdHeight.offsetHeight
						let ref_data = that.$refs.tdHeight
						that.tableShowData.forEach((res,index)=>{
							res.height = ref_data[index].offsetHeight
							// console.log(res.height)
						})
						// ref_data.forEach((res,index)=>{
						// 	console.log(index,res.offsetHeight)
							
						// })
						that.search_button_loading = false
						// console.log("that.tableShowData",that.tableShowData)
					}),200) // 设置200毫秒以上是为了获取数据更准确，如果设置100毫秒数据会不准
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},300)
			})
		},

		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton('分页')
		},
		// 多选测试
		onChangeCheckbox(checkedList,index) {
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
		    // that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			that.selected_number = nnn
		},
		// 全选
		onCheckAllChange(e) {
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				// that.selected_number = 0
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				// that.selected_number = that.tableShowData.length
				that.indeterminate = false
				that.checkAll = true
				
			}
			
		},
		// 复制投放地址
		thDzCopy(url){
			let that = this
			this.$copyText(url).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		},
		// 复制联调地址
		thLtCopy(e){
			let that = this
			if(e.put_platform === '头条'){
				let url = e.put_url + '?liantiao=1'
				this.$copyText(url).then(res=>{
					that.$message.success('复制成功');
				}).catch(err=>{
					that.$message.error('复制失败');
				})
			}
			else if(e.put_platform === '百度'){
				let url = e.put_url + '?bd_vid={bd_vid}&liantiao=1'
				this.$copyText(url).then(res=>{
					that.$message.success('复制成功');
				}).catch(err=>{
					that.$message.error('复制失败');
				})
			}
		},
		
		
		// 批量删除按钮
		plDelButton(){
			if(this.selectedData.length > 0){
				this.dl_modal = true
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		delReq(d_data){
			let that = this
			that.dl_loading = true
			
			// 批量删除请求
			landQaDel({
				id: d_data
			}).then(res=>{
				that.dl_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('删除成功');
					
					that.dlCancel()
					that.searchButton()
				}
				else {
					that.$message.error('删除失败');
				}
			})
		},
		// 批量删除确认
		dlOk(){
			let that = this
			
			let d_data = []
			that.selectedData.forEach(res=>{
				d_data.push(res.id)
			})
			console.log("d_data",d_data);
			that.delReq(d_data)
		},
		// 表格内删除按钮
		thDel(e){
			let that = this
			console.log(e);
			this.$confirm({
				title: '确定要删除吗?',
				content: `落地页名称：${e.title}`,
				okText: '删除',
				okType: 'danger',
				cancelText: '取消',
				onOk() {
				  // let d_data = []
				  // d_data.push(e.id)
				  // that.delReq(d_data)
				  that.delReq(e.id)
				},
				onCancel() {
				  console.log('Cancel');
				},
			});
			
		},
		// 删除弹窗取消
		dlCancel(){
			if(this.dl_loading){
				return
			}
			
			this.dl_modal = false
		},
		
		setFfRadio(e){ // 单选。选择开启或关闭
			console.log(e.target.value);
			this.r_is_supply_active_pay = e.target.value
		},
		plCancel(){
			if(this.pl_loading){
				return
			}
			
			this.pl_modal = false
		},
		
		
		
		
		// 回传比例
		returnRatio(e,type){
			let that = this
			console.log(e);
			this.hc_land_title = e.title
			this.hc_link_id = e.id
			if(type == 1){ // 回传比例修改记录
				that.hc_drawer_title = "回传比例修改记录"
				that.search_button_loading = true
				logReportPer({
					link_id: e.id
				}).then(res=>{
					that.search_button_loading = false
					console.log("回传比例修改记录",res);
					that.hcTableShowData = res.data.data.data
					that.hc_total = res.data.data.total
					that.hc_visible = true
				})
				
				
			}
			else if(type == 2){ // 添加回传比例任务
				this.hc_drawer_title = "添加回传比例任务"
				this.hc_visible = true
			}
		},
		// 回传侧边栏表格分页
		hcPaginationChange(e){
			let that = this
			this.hc_page = e
			logReportPer({
				link_id: e.id,
				page: that.hc_page,
				hc_limit: that.hc_limit
			}).then(res=>{
				console.log("回传比例修改记录",res);
				that.hcTableShowData = res.data.data.data
				that.hc_total = res.data.data.total
			})
		},
		// 回传比例侧边栏关闭
		hcCloseDrawer(){
			if(this.hc_button_loading){
				return
			}
			
			this.hc_visible = false
			this.hc_form_hint = ""
			this.hcTimeData = [
				{hc_time_value: '00:00:00', hc_number_value: 100, hc_time_open2: false,}
			]
			this.hc_switch_checked = false
			
			this.hc_page = 1
			
			document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			setTimeout(()=>{
				document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			},300)
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 时间选择关闭
		hcTimeClose(index){
			this.hcTimeData[index].hc_time_open2 = false
		},
		disabledDate(current){
			return current && current < moment().subtract(1,"days")
		},
		// 回传比例侧边栏 开关按钮
		hcDrawerSwitch(e){
			console.log(e);
			this.hc_switch_checked = e
		},
		// 回传比例时间选择
		hcTimeChange(ee,index){
			// console.log(moment(hc_time_value, 'HH:mm:ss'));
			console.log(ee,index);
			this.hcTimeData[index].hc_time_value = ee[1]
		},
		// 添加定时任务
		pushHcTimeData(){
			this.hcTimeData.push({hc_time_value: '00:00:00', hc_number_value: 100, hc_time_open2: false,})
		},
		// 删除定时任务
		delTimeData(index){
			if(this.hcTimeData.length > 1){
				this.hcTimeData.splice(index,1)
			}
			
		},
		// 回传比例确认按钮
		hcRequest(){
			let that = this
			
			that.hc_button_loading = true
			
			console.log(this.hcTimeData);
			// let tt = that.hc_time_value.split(':')
			// let r_tt = Number(tt[0])*60*60 + Number(tt[1])*60 + Number(tt[2])
			console.log("this.hcTimeData",this.hcTimeData);
			let r_time_obj = {}
			this.hcTimeData.forEach(res=>{
				let tt = res.hc_time_value.split(':')
				let r_tt = Number(tt[0])*60*60 + Number(tt[1])*60 + Number(tt[2])
				r_time_obj[r_tt] = res.hc_number_value
			})
			console.log("r_time_obj",r_time_obj);
			
			let r_status
			if(that.hc_switch_checked){ // 开启
				r_status = 1
			}
			else {
				r_status = 0 // 关闭
			}
			
			let r_data = {
				link_id: that.hc_link_id, // 落地页id
				start_time: that.startTime.replace(/-/g, ''), // 任务开始时间
				end_time: that.endTime.replace(/-/g, ''), // 任务结束时间
				status: r_status, // 状态0=关闭，1=开启
				time: r_time_obj
			}
			setReportPerPlan(r_data).then(res=>{
				console.log("回传比例确认按钮",res);
				that.hc_button_loading = false
				if(res.data.code == 0){
					that.hcCloseDrawer()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.hc_form_hint = res.data.msg
				}
			})
		},
		
		// 新增部分开始------
		// 显示新增侧边栏
		addShowDrawer(e){
			this.$router.push({path: '/landQuickAppAdd'})
		},
		// 编辑
		editLand(e){
			this.$router.push({ path:'/landQuickAppAdd',query:{link_id: e.id}})
		},
		
		
		// 单项修改
		editTd(e,type){
			console.log(e);
			if(type == 1){ // 修改回传比例
				this.e_id = e.id
				this.e_report_per = e.report_per
				this.edit_visible = true
			}
		},
		editModalOk(){
			let that = this
			
			if(!that.e_report_per){
				this.$message.warning('内容不能为空');
				
			}
			else {
				that.edit_confirmLoading = true
				landPageSingleEdit({
					id: that.e_id,
					report_per: that.e_report_per,
				}).then(res=>{
					console.log("编辑",res);
					that.confirmLoading = false
					if(res.data.code == 0 || res.data.code === 200 || res.data.code == 8011){
						that.editModalCancel()
						that.$message.success('编辑成功');
						that.searchButton()
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						that.$message.error(res.data.msg || "请求失败");
					}
				})
			}
		},
		editModalCancel(){
			let that = this
			this.e_admin_id = undefined
			this.edit_visible = false
		},
		
		// 点击落地页名字
		ldTitleClick(item){
			// console.log('点击落地页名字',item);
			item.title_input_control = !item.title_input_control
			this.ld_change_tilte = item.title
			this.$nextTick(() => {
				// console.log(this.$refs.title_input);
				this.$refs.title_input[0].focus()
			})
		},
		// 落地页名称输入框失去焦点
		LdTitleChange(e,item,index){
			let that = this
			// console.log("失去焦点",e.target.value);
			item.title_input_control = false
			// console.log("失去焦点item",item);
			if(e.target.value != this.ld_change_tilte){ // 不相等说明有改动
				landPageSingleEdit({
					id: item.id,
					title: e.target.value
				}).then(res=>{
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('修改落地页名称成功');
						that.tableShowData[index].title = e.target.value
					}
					else {
						that.$message.error(res.data.msg || '修改落地页名称失败');
					}
				})
			}
			
		},
	},
	filters: {
		jumpTypeFil(value){
			// console.log("过滤器",value)
			// 跳转页，有内容落地页
			let vvv 
			if(value == 1){
				vvv = "跳转页"
			}
			else{
				vvv = "其他(暂时没有其他内容)"
			}
			
			return vvv
		},
		putPlatformFil(value){
			let vvv
			if(value == 4){
				vvv = "华为"
			}
			else{
				vvv = "其他(暂时没有其他内容)"
			}
			
			return vvv
		}
		
	}
}
</script>

<style scoped>

.button-right {
	margin-right: 20px;
}


.td-cz {
	margin-right: 7px;
	margin-bottom: 3px;
	cursor: pointer;
	font-size: 13px;
}


.hc-drawer-title {
	margin-right: 10px
}

.table-td-cell {
	font-size: 13px;
}

/* 表格内的小程序 */
.xcx-cell,
.xcx-cell-false {
	padding: 1px 7px;
	margin-bottom: 5px;
	margin-right: 7px;
	text-align: center;
	border-radius: 3px;
	font-size: 12px;
}
.xcx-cell {
	color: #fff;
	background-color: #62a8ea;
}
.xcx-cell-false {
	color: #fff;
	background-color: #999;
}

/* 必填提示 */
.required-hint {
	color: red;
	position: absolute;
	right: -8px;
}
</style>